<template>
    <div>
        <form @submit.prevent="resetPassword">
            <div class="u-margin-bottom">
                <div v-if="form.errors.first('token')">
                    <svg width="20" height="20" viewBox="0 0 20 20" class="icon | u-margin-right-inline">
                        <use xlink:href="../assets/feather-icons/icons.svg#info"></use>
                    </svg>
                    <span class="authentication__email-info">
                        <small>{{ trans('authentication.password-set.token_required') }}</small>
                    </span>
                </div>
                <text-input
                    v-model="form.email"
                    :error="form.errors.first('email')"
                    :label="trans('authentication.password-reset.fields.email')"
                    name="email"
                    class="field__label--register field__input--register | u-full-width"
                    required
                    focus
                />
            </div>

            <nav>
                <button
                    class="btn btn--auth button-blue-submit--ghost | u-margin-bottom-narrow u-full-width"
                    dusk="password-reset-button"
                    type="submit"
                >
                    {{ trans('authentication.password-reset.button') }}
                </button>
                <div class="authentication__form-links">
                    <router-link :to="{ name: 'login' }" class="u-margin-right">
                        {{ trans('authentication.password-reset.cancel') }}
                    </router-link>
                </div>
            </nav>
        </form>
    </div>
</template>

<script>
import { Way2Form } from 'relapp-way2forms';

export default {
    /**
     * Add all the properties found in the data object to Vue’s reactivity system.
     *
     * @return {object}
     */
    data() {
        return {
            form: new Way2Form({
                email: null
            })
        };
    },
    methods: {
        /**
         * Submit set password form
         */
        resetPassword() {
            this.$emit('submit', this.form);
        }
    }
};
</script>
